import React, { useState, useEffect } from "react";
import { Block, BlockDes, BlockHead, BlockHeadContent, BlockTitle, PreviewCard, Row, Col, } from "../../components/Component";
import { Card, DropdownItem, UncontrolledDropdown, DropdownMenu, DropdownToggle, Badge } from "reactstrap";
// import {
//   BlockHead,
//   BlockDes,
//   BlockTitle,
//   BlockBetween,
//   BlockHeadContent,
//   Icon,
//   Button,
//   Block,
//   PaginationComponent,
// } from "../../../components/Component";
import RegularImage from "../../images/slides/slide-b.jpg";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import Header from "../../layout/header/Header";
import './style.scss';

const Regularv1 = ({ ...props }) => {

  const [themeState] = useState({
    main: "default",
    sidebar: "white",
    header: "white",
    skin: "light",
  });

  useEffect(() => {
    document.body.className = `nk-body bg-lighter npc-default has-sidebar no-touch nk-nio-theme ${themeState.skin === "dark" ? "dark-mode" : ""
      }`;
  }, [themeState.skin]);

  return (
    <React.Fragment>
      <Header fixed theme={themeState.header} plainHeader={true} />
      {/* <Head title="Regular page v-1" /> */}
      <Content>
        {/* <BlockHead size="lg" wide="xs" className="mx-auto">
          <BlockHeadContent className="text-center">
            <BlockTitle tag="h2" className="fw-normal">
              Regular Page Title
            </BlockTitle>
            <BlockDes>
              <p className="lead">
                We love to share ideas! Visit our blog if you're looking for great articles or inspiration to get you
                going.
              </p>
            </BlockDes>
          </BlockHeadContent>
        </BlockHead> */}
        <Block>
          <PreviewCard bodyClass="card-inner-xl">

          <h1 className="ff-base fw-medium">Aza Designer Panel</h1>

            <Row className="g-gs">

              <Col xxl={4} lg={4} sm={6}>
                {/* <div class="card"> */}
                <div>
                  <div class="card-body" style={{ padding: '4.5rem' }}>
                    <div className="preview-icon-wrap title-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
                        <rect
                          width="60"
                          height="56"
                          x="5"
                          y="7"
                          fill="#e3e7fe"
                          stroke="#6576ff"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          rx="7"
                          ry="7"
                        ></rect>
                        <rect
                          width="60"
                          height="56"
                          x="25"
                          y="27"
                          fill="#e3e7fe"
                          stroke="#6576ff"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          rx="7"
                          ry="7"
                        ></rect>
                        <rect
                          width="60"
                          height="56"
                          x="15"
                          y="17"
                          fill="#fff"
                          stroke="#6576ff"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          rx="7"
                          ry="7"
                        ></rect>
                        <path fill="none" stroke="#6576ff" strokeMiterlimit="10" strokeWidth="2" d="M15 29L75 29"></path>
                        <circle cx="53" cy="23" r="2" fill="#c4cefe"></circle>
                        <circle cx="60" cy="23" r="2" fill="#c4cefe"></circle>
                        <circle cx="67" cy="23" r="2" fill="#c4cefe"></circle>
                        <rect
                          width="20"
                          height="20"
                          x="22"
                          y="39"
                          fill="none"
                          stroke="#6576ff"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          rx="2"
                          ry="2"
                        ></rect>
                        <circle
                          cx="32"
                          cy="45.81"
                          r="2"
                          fill="none"
                          stroke="#6576ff"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                        ></circle>
                        <path
                          fill="none"
                          stroke="#6576ff"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M29 54.31a3 3 0 016 0"
                        ></path>
                        <path
                          fill="none"
                          stroke="#6576ff"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M49 40L69 40"
                        ></path>
                        <path
                          fill="none"
                          stroke="#c4cefe"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M49 51L69 51"
                        ></path>
                        <path
                          fill="none"
                          stroke="#c4cefe"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M49 57L59 57"
                        ></path>
                        <path
                          fill="none"
                          stroke="#c4cefe"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M64 57L66 57"
                        ></path>
                        <path
                          fill="none"
                          stroke="#c4cefe"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M49 46L59 46"
                        ></path>
                        <path
                          fill="none"
                          stroke="#c4cefe"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M64 46L66 46"
                        ></path>
                      </svg>
                    </div>

                    {/* <img style={{ width: '100px', height: '100px', margin: 'auto', borderRadius: '50%', display: 'flex' }} src="https://st3.depositphotos.com/7023650/18693/v/600/depositphotos_186931594-stock-illustration-bright-poster-with-splatter-illustration.jpg" alt="Card image cap" /> */}
                    <h3 className="ff-base fw-medium"><a>Create and maintain an account</a></h3>
                    <p className="lead">Create your designer account with a simple registration form. Maintain your basic, communication and financial details easily from your profile section.</p>
                  </div>
                </div>
              </Col>


              <Col xxl={4} lg={4} sm={6}>
                <div>
                  <div class="card-body" style={{ padding: '4.5rem' }}>

                    <div className="preview-icon-wrap title-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
                        <path
                          fill="#eff1ff"
                          stroke="#6576ff"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M40.74 5.16l38.67 9.23a6 6 0 014.43 7.22L70.08 80a6 6 0 01-7.17 4.46l-38.68-9.24A6 6 0 0119.81 68L33.56 9.62a6 6 0 017.18-4.46z"
                        ></path>
                        <path
                          fill="#eff1ff"
                          stroke="#6576ff"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M50.59 6.5l-39.41 5.23a6 6 0 00-5.13 6.73L13.85 78a6 6 0 006.69 5.16l39.4-5.23a6 6 0 005.14-6.73l-7.8-59.49a6 6 0 00-6.69-5.21z"
                        ></path>
                        <rect
                          width="54"
                          height="70"
                          x="15"
                          y="15"
                          fill="#fff"
                          stroke="#6576ff"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          rx="6"
                          ry="6"
                        ></rect>
                        <path
                          fill="none"
                          stroke="#c4cefe"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M42 77L58 77"
                        ></path>
                        <circle cx="38" cy="77" r="0.5" fill="#c4cefe" stroke="#c4cefe" strokeMiterlimit="10"></circle>
                        <path
                          fill="none"
                          stroke="#c4cefe"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M42 72L58 72"
                        ></path>
                        <circle cx="38" cy="72" r="0.5" fill="#c4cefe" stroke="#c4cefe" strokeMiterlimit="10"></circle>
                        <path
                          fill="none"
                          stroke="#c4cefe"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M42 66L58 66"
                        ></path>
                        <circle cx="38" cy="66" r="0.5" fill="#c4cefe" stroke="#c4cefe" strokeMiterlimit="10"></circle>
                        <path
                          fill="#e3e7fe"
                          stroke="#6576ff"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M46 40l-15-.3v.3a15 15 0 1015-15h-.36z"
                        ></path>
                        <path
                          fill="#e3e7fe"
                          stroke="#6576ff"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M42 22a14 14 0 00-14 14h14V22"
                        ></path>
                        <path
                          fill="none"
                          stroke="#6576ff"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M33.47 30.07L28.87 23 23 23"
                        ></path>
                        <path
                          fill="none"
                          stroke="#6576ff"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M25 56L35 56 40.14 49"
                        ></path>
                      </svg>
                    </div>

                    {/* <img style={{ width: '100px', height: '100px', margin: 'auto', borderRadius: '50%', display: 'flex' }} src="https://st3.depositphotos.com/7023650/18693/v/600/depositphotos_186931594-stock-illustration-bright-poster-with-splatter-illustration.jpg" alt="Card image cap" /> */}
                    <h3 className="ff-base fw-medium"><a>Manage Products and inventory</a></h3>
                    <p className="lead">Provides you complete control on your inventory where you can update stock, pricing details and delivery timelines.</p>
                  </div>
                </div>
              </Col>


              <Col xxl={4} lg={4} sm={6}>
                <div>
                  <div class="card-body" style={{ padding: '4.5rem' }}>

                    <div className="preview-icon-wrap title-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114 113.9">
                        <path
                          fill="#c4cefe"
                          d="M83.84 108.24l-48.31-7.86a3.55 3.55 0 01-3.1-4l12.2-69.48a3.66 3.66 0 014.29-2.8l48.32 7.8a3.56 3.56 0 013.09 4l-12.2 69.52a3.66 3.66 0 01-4.29 2.82z"
                        ></path>
                        <path
                          fill="#c4cefe"
                          d="M29.73 103.29L74.66 96a3.41 3.41 0 002.84-3.94L65.4 22.95a3.5 3.5 0 00-4-2.82l-44.96 7.28a3.41 3.41 0 00-2.84 3.94l12.1 69.11a3.52 3.52 0 004.03 2.83z"
                        ></path>
                        <rect width="66" height="88" x="22" y="17.9" fill="#6576ff" rx="3" ry="3"></rect>
                        <rect width="48" height="10" x="31" y="85.9" fill="#fff" rx="1.5" ry="1.5"></rect>
                        <rect width="48" height="5" x="31" y="27.9" fill="#e3e7fe" rx="1" ry="1"></rect>
                        <rect width="23" height="3" x="31" y="37.9" fill="#c4cefe" rx="1" ry="1"></rect>
                        <rect width="20" height="3" x="59" y="37.9" fill="#c4cefe" rx="1" ry="1"></rect>
                        <rect width="23" height="3" x="31" y="45.9" fill="#c4cefe" rx="1" ry="1"></rect>
                        <rect width="20" height="3" x="59" y="45.9" fill="#c4cefe" rx="1" ry="1"></rect>
                        <rect width="48" height="3" x="31" y="52.9" fill="#e3e7fe" rx="1" ry="1"></rect>
                        <rect width="23" height="3" x="31" y="60.9" fill="#c4cefe" rx="1" ry="1"></rect>
                        <path
                          fill="#9cabff"
                          d="M94.5 113.9a.5.5 0 01-.5-.5v-1.5h-1.5a.5.5 0 010-1H94v-1.5a.5.5 0 011 0v1.5h1.5a.5.5 0 010 1H95v1.5a.5.5 0 01-.5.5zM12.5 82.9a.5.5 0 01-.5-.5v-1.5h-1.5a.5.5 0 010-1H12v-1.5a.5.5 0 011 0v1.5h1.5a.5.5 0 010 1H13v1.5a.5.5 0 01-.5.5zM3 10.9a3 3 0 113-3 3 3 0 01-3 3zm0-5a2 2 0 102 2 2 2 0 00-2-2zM109.5 68.9a4.5 4.5 0 114.5-4.5 4.51 4.51 0 01-4.5 4.5zm0-8a3.5 3.5 0 103.5 3.5 3.5 3.5 0 00-3.5-3.5z"
                        ></path>
                        <path
                          fill="#2ec98a"
                          d="M103.66 4.95A5.66 5.66 0 0099.57.9a47.45 47.45 0 00-18.09 0 5.66 5.66 0 00-4.08 4.06 47.51 47.51 0 000 18.1 5.67 5.67 0 004.08 4.07 47.57 47.57 0 009 .87 47.78 47.78 0 009.06-.87 5.66 5.66 0 004.08-4.09 47.45 47.45 0 00.04-18.09z"
                        ></path>
                        <path
                          fill="#fff"
                          d="M96.66 10.71l-1.35 1.47c-1.9 2.06-3.88 4.21-5.77 6.3a1.29 1.29 0 01-1 .42 1.27 1.27 0 01-1-.42c-1.09-1.2-2.19-2.39-3.28-3.56a1.29 1.29 0 011.88-1.76c.78.84 1.57 1.68 2.35 2.54 1.6-1.76 3.25-3.55 4.83-5.27l1.35-1.46a1.29 1.29 0 011.9 1.74z"
                        ></path>
                      </svg>
                    </div>

                    {/* <img style={{ width: '100px', height: '100px', margin: 'auto', borderRadius: '50%', display: 'flex' }} src="https://st3.depositphotos.com/7023650/18693/v/600/depositphotos_186931594-stock-illustration-bright-poster-with-splatter-illustration.jpg" alt="Card image cap" /> */}
                    <h3 className="ff-base fw-medium"><a>Order Management</a></h3>
                    <p className="lead">
                    Easily track and dispatch your purchase orders from our dashboard for better order fulfilments.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>

          </PreviewCard>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default Regularv1;
